'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionIntroCarousel = function () {
  function CollectionIntroCarousel(el) {
    (0, _classCallCheck3.default)(this, CollectionIntroCarousel);

    this.el = el;
    this.scrollAmount = 100;

    this.initialiseCarousel();
  }

  (0, _createClass3.default)(CollectionIntroCarousel, [{
    key: 'initialiseCarousel',
    value: function initialiseCarousel() {
      var _this = this;

      this.setStartOrEnd = (0, _utils.debounce)(this.setStartOrEnd.bind(this), 100);

      this.setStartOrEnd();

      // Detect scroll of the element.
      this.el.addEventListener('scroll', this.setStartOrEnd);

      window.addEventListener('resize', this.setStartOrEnd);

      // Setup custom buttons
      if (this.previousEl && this.nextEl) {
        this.previousEl.addEventListener('click', function () {
          // Smooth scroll 20px to the left.
          _this.el.scrollTo({
            left: _this.el.scrollLeft - _this.scrollAmount,
            behavior: 'smooth'
          });
        });

        this.nextEl.addEventListener('click', function () {
          // Smooth scroll 20px to the right.
          _this.el.scrollTo({
            left: _this.el.scrollLeft + _this.scrollAmount,
            behavior: 'smooth'
          });
        });
      }
    }
  }, {
    key: 'setStartOrEnd',
    value: function setStartOrEnd() {
      var scrollLeft = this.el.scrollLeft;
      var scrollRight = this.el.scrollWidth - this.el.clientWidth - this.el.scrollLeft;

      if (scrollRight <= 1) {
        this.el.parentElement.dataset.atEnd = true;
      }

      if (scrollRight > 1) {
        this.el.parentElement.dataset.atEnd = false;
      }

      if (scrollLeft <= 1) {
        this.el.parentElement.dataset.atStart = true;
      }

      if (scrollLeft > 1) {
        this.el.parentElement.dataset.atStart = false;
      }
    }
  }, {
    key: 'previousEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-intro-carousel-el="previous"]', {
        context: this.el
      });
    }
  }, {
    key: 'nextEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-intro-carousel-el="next"]', {
        context: this.el
      });
    }
  }, {
    key: 'slidesEl',
    get: function get() {
      return (0, _functional.getElement)('[data-collection-intro-carousel-el="slides"]', {
        context: this.el
      });
    }
  }]);
  return CollectionIntroCarousel;
}();

exports.default = CollectionIntroCarousel;